import { DocumentFileLink } from "@entities/journal";
import { resolveFilestoreDocumentUrl } from "../../model/resolve-filestore-document-url";

type DocumentModalTitleCellProps = {
  title: string;
  originalData?: Record<string, unknown> | null;
};

export function DocumentModalTitleCell({
  title,
  originalData,
}: DocumentModalTitleCellProps) {
  const documentUrl = resolveFilestoreDocumentUrl(originalData);

  return (
    <DocumentFileLink
      className="selectable-link"
      fileName={title}
      documentUrl={documentUrl}
    />
  );
}
